import React, { useState } from 'react'
import Text from '../../Text'
import shopItemStyles from '../styles.module.css'
import { useRegionShippingInfo } from '../../RegionGeo'
import { $interactivePrimary, $textPrimary, $textTertiary, $textInteractive } from '../../../styles/colors/semantics'
import { $black, $neutralGray100, $neutralGray30, $neutralGray70 , $white } from '../../../styles/colors/primitives'
import { buildCheckoutPageUrlFromProductSetId } from '../../../utils/shopItems'
import { useUrlRegion } from '../../../utils/useCurrentRegion'
import ProgressiveImage from '../../sections/ProgressiveImage'
import MyLoader from '../../Utils/MyLoader'
import SmartLink from '../../SmartLink'
import { formatPrice } from '../../../utils/formats'
import Spacer from '../../Spacer'
import TimeOrStockLimitCountdownBF2025 from '../../Utils/Countdown/ItemCountdownBF2025'
import styles from './styles.module.css'
import UnlockIcon from '../../icons/UnlockIcon'
import HolidaySaleTag from '../HolidaySaleTag'

function ShopItemBF2025({ dark, isLoading, name, typeNames, freeBonuses, mainImage, hoverImage, regularPriceObj,
                    discountPriceObj, priceObj, price, discountPrice, outOfStock, outOfStockMessage, isNew,
                    isPreOrder, productSetId, pricePrefix, timeLimit, stockLimit, stockLimitLeft }) {
  const region = useUrlRegion()
  const shippingInfo = useRegionShippingInfo()

  // taxIncluded = taxIncluded ? taxIncluded.replaceAll(/ *\([^)]*\) */g, '').trim() : null
  const hasFreeShipping = shippingInfo && shippingInfo.freeShipping
  const hasDiscount = !!discountPrice && discountPrice !== price
  const discountPercentage = hasDiscount && !!price && (100 - (discountPriceObj.priceCents / regularPriceObj.priceCents) * 100).toFixed(0)
  const youSave = hasDiscount && !!price && (- (discountPriceObj.priceCents - regularPriceObj.priceCents))

  const isLiteWheel = name === 'Lite Formula Steering Wheel'

  if (isLoading) {
    return (
      <div className={shopItemStyles.loaderWrapper} style={{ background: dark ? $neutralGray100 : $white }}>
        <MyLoader isLoading={isLoading}/>
      </div>
    )
  }

  return (
    <SmartLink
      href={buildCheckoutPageUrlFromProductSetId(productSetId, region)}
      className={[shopItemStyles.wrapper, !hoverImage ? null : shopItemStyles.wrapperHoverable].filter(Boolean).join(' ')}
      style={{ background: dark ? $black : 'transparent', color: dark ? $textPrimary.dark : 'inherit' }}
    >
        <div
          className={[shopItemStyles.imageWrapper, (outOfStock && !isNew) ? shopItemStyles.imageWrapperDisabled : null].filter(Boolean).join(' ')}
          style={{ background: dark ? $neutralGray100 : '#F4F4F4' }}
        >
          <div className={shopItemStyles.mainImage + ' main-image'}><ProgressiveImage {...mainImage}/></div>
          <div className={shopItemStyles.hoverImage + ' hover-image'}><ProgressiveImage {...hoverImage}/></div>
          <HolidaySaleTag show={true}/>
          { renderBonusBIG(Object.keys(freeBonuses)[0], freeBonuses[Object.keys(freeBonuses)[0]]) }
        </div>
        { youSave && youSave > 0 && <div className={styles.youSaveWrapper} style={{ background: $interactivePrimary.light }}>
          <Text type={'heading-4'} color={$white}>YOU SAVE {formatPrice({ priceCents: youSave, currency: priceObj.currency })}</Text>
          { isLiteWheel && <Text type={'medium'} color={$white}>FINAL STOCK</Text> }
        </div>}
        { (timeLimit || stockLimit > 0) && <TimeOrStockLimitCountdownBF2025 launchDate={new Date(timeLimit)} stockLimit={stockLimit} stockLimitLeft={stockLimitLeft} theme="holiday"
                                                                            subtitle={isLiteWheel ? 'Last Lite Wheels in our warehouse. No restock planned.' : null}
        /> }
        <div className={shopItemStyles.itemInfoWrapper}>
          <div className={shopItemStyles.priceAndTaxWrapper}>
            <div className={shopItemStyles.priceWrapper}>
              {pricePrefix && <Text type={'heading-7'}>{pricePrefix}</Text>}
              <div
                className={[shopItemStyles.discountPrice, hasDiscount ? shopItemStyles.shown : shopItemStyles.hidden].join(' ')}
                style={{ background: dark ? $black : 'transparent', color: $textInteractive.light }}
              >
                <Text type="heading-5">{discountPrice}</Text>
              </div>
              <div className={shopItemStyles.priceAndDiscountPercentage} style={{ background: dark ? $black : 'transparent' }}>
                <div
                  className={[shopItemStyles.price, hasDiscount ? shopItemStyles.priceHasDiscount : null].filter(Boolean).join(' ')}
                  style={hasDiscount ? { color: $textTertiary.light } : undefined}
                >
                  <Text type={hasDiscount ? 'small' : 'heading-7'}>{price}</Text>
                </div>
                {
                  discountPercentage > 0 && <div className={shopItemStyles.discountPercentage} style={{ color: dark ? $textInteractive.light : 'transparent' }}>
                    <Text type="tiny">-{discountPercentage}%</Text>
                  </div>
                }
              </div>
            </div>
          </div>
          <div className={shopItemStyles.title}>
            <Text type="medium" color={dark ? $textPrimary.dark : $textPrimary.dark}>{name}</Text>
            <Spacer size={4}/>
            { typeNames && typeNames.map(n => <Text type="small" key={n} color={dark ? $textTertiary.dark : $textTertiary.light}>{n}</Text>) }
            { renderBonuses(freeBonuses) }
          </div>
          <div
            className={[shopItemStyles.outOfStockTag, outOfStock ? shopItemStyles.shown : shopItemStyles.hidden].join(' ')}
            style={{ background: $neutralGray30, color: $neutralGray70 }}
          >
            <Text type="tiny">{outOfStockMessage}</Text>
          </div>
        </div>
    </SmartLink>
  )
}

const renderBonuses = (freeBonuses) => {
  if(!freeBonuses || Object.keys(freeBonuses).length === 0) return null
  return (
    <div className={shopItemStyles.bonuses}>
      { freeBonuses && Object.keys(freeBonuses).map(k => (
        <>
          <Text type="small"
                color={$textTertiary.dark}
          >{ k } worth {formatPrice(freeBonuses[k])}</Text>
        </>
      ))
      }
    </div>
  )
}

const renderBonusBIG = (bonus, price) => {
  if(!bonus) return null
  return (
    <div className={styles.bigBonusWrapper}>
      { bonus && <div className="flex items-center justify-center gap-1">
          <div className="hidden lg:block">
            <UnlockIcon/>
          </div>
          <Text type="heading-9"
                color={$textPrimary.dark}
          >{ bonus } worth {formatPrice(price)}</Text>
        </div>
      }
    </div>
  )
}

export default ShopItemBF2025
